import { PlanEstudioI } from "interfaces/PlanEstudio";
import React, { ReactNode } from "react";
import { Badge } from "react-bootstrap";
import { formatDate } from "utils/formatUtils";

interface Props {
  elemento: PlanEstudioI;
  renderActions?: (elemento: PlanEstudioI) => ReactNode;
}

export const PlanesRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`ResolucionTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        <td>{elemento.cantidad_anios}</td>
        <td>{elemento.alcance.nombre}</td>
        <td>{formatDate.stringDate(elemento.fecha_publicacion)}</td>
        <td>{elemento.disenio_curricular.nombre}</td>
        {/* <td>{elemento.titulos.map((ctE) => ctE.nombre).join(" - ")}</td> */}
        {/* <td>{elemento.normativas.map((ctE) => ctE.nombre).join(" - ")}</td> */}
        <td>
          {elemento?.aplicaValidezNacional ? (
            <Badge
              bg={"none"}
              style={{
                color: "#26874A",
                backgroundColor: "#F5FCF8",
                borderColor: "#26874A",
              }}
            >
              Activo
            </Badge>
          ) : (
            <Badge
              bg={"none"}
              style={{
                color: "#ff0000",
                backgroundColor: "#F5FCF8",
                borderColor: "#ff0000",
              }}
            >
              Inactivo
            </Badge>
          )}
        </td>
        {renderActions && <td>{renderActions(elemento)}</td>}
      </tr>
    </>
  );
};
